module.exports = __webpack_public_path__ + "packs/media/images/Angelo-4e2677b4a9eb60df42862258318c5688.jpg";